import { Component } from "vue-property-decorator"

import FDropdownBase from "./fDropdown.client.base"

@Component
export default class FDropdownWeb extends FDropdownBase {}
